import type { GetStaticProps, InferGetStaticPropsType } from 'next'
import { type DehydratedState, dehydrate, QueryClient } from '@tanstack/react-query'
import { type FC, useMemo } from 'react'

import { UseCasesView } from 'views/UseCases'

import { createFetchUseCasesQuery, createFiltersQuery } from '@segment/api/routes/useCases/queries'

import { createClient } from '@segment/api/staticSiteBackend/client'

import { createStaticSiteBackend, StaticSiteBackendProvider } from '@segment/contexts/staticSiteBackend'

import type { AppExternalPageProps } from '@segment/next-shared/Providers'

const UseCasesPage: FC<InferGetStaticPropsType<typeof getStaticProps>> = () => {
  const staticSiteBackend = useMemo(() => createStaticSiteBackend(), [])

  return (
    <StaticSiteBackendProvider value={staticSiteBackend}>
      <UseCasesView />
    </StaticSiteBackendProvider>
  )
}

export default UseCasesPage

export const getStaticProps: GetStaticProps<AppExternalPageProps> = async () => {
  const queryClient = new QueryClient()
  const client = createClient()

  await queryClient.prefetchInfiniteQuery(...createFetchUseCasesQuery(client, { useCase: [] }), { staleTime: Infinity })

  await queryClient.prefetchQuery(...createFiltersQuery(client), { staleTime: Infinity })

  const dangerousDehydratedState = dehydrate(queryClient)

  const safeDehydratedState: DehydratedState = JSON.parse(JSON.stringify(dangerousDehydratedState))

  const props: AppExternalPageProps = {
    dehydratedState: safeDehydratedState,
  }

  return {
    props,
  }
}
